import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import isArray from 'lodash/isArray';
import classNames from 'classnames';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from 'aurora-translations';
import isEmpty from 'lodash/isEmpty';

import { ADGMTextField, ADGMItemDetails, LightTooltipComponent } from 'aurora-components';
import { CleverTapValidatePremise } from 'aurora-utils/cleverTap.eventhelper';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './styles';
// eslint-disable-next-line import/no-cycle
import PrimaryContactLessor from './PrimaryContactLessor';
// import OnwaniAddress from './OnwaniAddress';

function LeaseUnitDetails(props) {
  const {
    intl,
    classes,
    panel,
    form,
    propertyDetail,
    isRenewal,
    isAmendment,
    handleFetchPremise,
    isRegistration,
    handleChange,
    // onwaniAddress,
    applicationId,
    applicationStatus,
    applicationNumber,
    applicationType,
    handleFetchAllPremises,
    isMultipleUnits,
    currentStep,
    selectedProperties,
    premiseIdError,
  } = props;
  const [premiseNumber, setPremiseNumber] = useState('');
  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );
  const isDisabledFetchAllUnits = useMemo(() => {
    if (
      isEmpty(form?.premiseNumber) ||
      (isArray(form?.premiseNumber) &&
        isEmpty(form?.premiseNumber?.filter(premis => premis?.premiseNumber && !premis?.premiseAddress)))
    ) {
      return true;
    }
    return false;
  }, [form?.premiseNumber]);
  const isMultipleUnitCase = useMemo(() => {
    if (isMultipleUnits) return true;
    return false;
  }, [isMultipleUnits]);
  useEffect(() => {
    if (isMultipleUnitCase && isEmpty(form?.premiseNumber)) {
      handleChange('premiseNumber', selectedProperties);
    }
  }, [isMultipleUnitCase, selectedProperties, form?.premiseNumber]);

  useEffect(() => {
    if (form.premiseNumber) {
      setPremiseNumber(form.premiseNumber);
      return;
    }
    if (propertyDetail?.premiseNumber) {
      setPremiseNumber(propertyDetail?.premiseNumber);
    }
  }, [propertyDetail]);
  useEffect(() => {
    if (form?.premisesAddress) {
      const payload = {
        applicationType,
        premiseId: premiseNumber,
        applicationStatus,
        applicationId,
        applicationNumber,
        isSuccess: true,
      };
      CleverTapValidatePremise(payload);
    }
  }, [premiseNumber]);

  const checkPremiseIdStatus = () => {
    if (isRegistration) {
      return false;
    }
    // if (isAmendment) return true;
    if (isAmendment) return false;
    if (isRenewal) {
      // if (form.premiseNumber || propertyDetail?.premiseNumber) return true;
      if (form.premiseNumber || propertyDetail?.premiseNumber) return false;
      return false;
    }
    return false;
  };

  function handlePremiseChange(plotId, value) {
    const selectedUnit = form?.premiseNumber?.findIndex(premise => premise?.plotId === plotId);

    const newArr = [...form?.premiseNumber];
    newArr[selectedUnit] = {
      ...form?.premiseNumber[selectedUnit],
      premiseNumber: value,
      premiseAddress: null,
      failed: false,
    };
    handleChange('premiseNumber', newArr);
  }
  return (
    <>
      {currentStep === 0 && (
        <PrimaryContactLessor
          form={{ ...form, applicationId }}
          handleChange={handleChange}
          ownerships={propertyDetail?.ownerships}
        />
      )}
      {!(currentStep === 0 && isMultipleUnitCase) && (
        <Paper key={panel?.id} className={classNames(classes.paperTypeBlock)}>
          <Box justifyContent='space-between' className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.title}>
              {keyEmptyCheck(isMultipleUnits ? 'Properties' : 'lease_unit_details')}
              <span className={classes.subTitle1}>*</span>
            </Typography>

            {isMultipleUnitCase && (
              <Button
                disabled={isDisabledFetchAllUnits}
                onClick={handleFetchAllPremises}
                variant='outlined'
                className={classNames(classes.outlinedBtn2, classes.fetchAllUnitsBtn)}
                size='large'
              >
                {keyEmptyCheck('fech_unit_details')}
              </Button>
            )}
          </Box>
          <div
            className={
              !isMultipleUnits
                ? classNames(classes.innerCard, classes.innerCardGridRemovePadding)
                : classNames(classes.innerCardMultiple)
            }
          >
            <div
              className={classNames({
                [classes.blurryInnerGrid]: checkPremiseIdStatus(),
              })}
            />
            {/* For Single Unit */}
            {!isMultipleUnitCase && (
              <div className={classes.premiseWrapper}>
                <LightTooltipComponent dark title={keyEmptyCheck('addc_registration_no')}>
                  <Typography component='p' className={classNames(classes.label, classes?.label)}>
                    {keyEmptyCheck('premise_id')} <span className={classes.textADGMRed}>*</span>
                  </Typography>
                </LightTooltipComponent>
                <div className={classes.premiseContainer}>
                  <ADGMTextField
                    id='premiseNumber'
                    name='premiseNumber'
                    variant='outlined'
                    placeholder={intl.formatMessage({ ...messages.enter_premise_id })}
                    type='text'
                    value={premiseNumber}
                    mask={createNumberMask(numberMaskWithoutDecimalOption)}
                    onChange={e => {
                      handleChange('', '', {
                        premiseNumber: e.target.value,
                        premisesAddress: '',
                      });
                      setPremiseNumber(e.target.value);
                    }}
                    // label={intl.formatMessage({ ...messages.premise_id })}
                    required
                    disabled={checkPremiseIdStatus()}
                    // isPreFilled={premiseNumber}
                    tabIndex={(isRenewal || isAmendment) && '-1'}
                  />
                  <Button
                    variant='contained'
                    color='secondary'
                    disabled={premiseNumber?.length < 1}
                    tabIndex={(isRenewal || isAmendment) && '-1'}
                    onClick={() => handleFetchPremise(premiseNumber)}
                  >
                    <FormattedMessage {...messages.get_details} />
                  </Button>
                </div>
                <div className={classes.informationMessage}>
                  {/* <ADGMAlert type='info' noBackground> */}
                  <FormattedMessage {...messages.Enter_UN_EID_number_fetch_person_details_web} />
                  {/* </ADGMAlert> */}
                </div>
                <div className={classes.premiseAddressField}>
                  <ADGMItemDetails
                    label='premise_address'
                    value={form?.premisesAddress}
                    labelClass={classes.lightWeightLable}
                    valueClass={classes.lightWeightValue}
                  />
                </div>
              </div>
            )}
            {/* For Multple units */}
            {isMultipleUnitCase && !isEmpty(form?.premiseNumber) && (
              <>
                {form?.premiseNumber?.map(unit => (
                  <Grid key={unit?.plotId} container className={classes.premiseUnitContainer}>
                    <Grid
                      md={3}
                      xs={12}
                      item
                      className={classNames(classes.premiseContent, classes.premiseContentMobile)}
                    >
                      <Box>
                        <ADGMItemDetails
                          label='unit_number'
                          value={unit?.unitNumber}
                          labelClass={classes.lightWeightLable}
                          valueClass={classes.lightWeightValue}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      md={3}
                      xs={12}
                      item
                      className={classNames(classes.premiseContent, classes.premiseContentMobile)}
                    >
                      <Box className={classes.premiseContentMobile2}>
                        <ADGMItemDetails
                          label='unit_reg_no_text'
                          value={unit?.unitRegNumber}
                          labelClass={classes.lightWeightLable}
                          valueClass={classes.lightWeightValue}
                        />
                      </Box>
                    </Grid>

                    <Grid
                      md={3}
                      xs={12}
                      item
                      className={classNames(classes.premiseContent, classes.premiseContentMobile)}
                    >
                      <Box className={classes.premiseInputContainer} display='flex' alignItems='flex-end'>
                        <Box className={classes.premiseInput}>
                          <ADGMTextField
                            id='premiseNumber'
                            name='premiseNumber'
                            variant='outlined'
                            placeholder={intl.formatMessage({ ...messages.enter_premise_id })}
                            type='text'
                            value={unit?.premiseNumber}
                            mask={createNumberMask(numberMaskWithoutDecimalOption)}
                            onChange={e => {
                              handlePremiseChange(unit?.plotId, e.target.value);
                              // handleChange('premiseNumber', [...form?.premiseNumber, e.target.value]);
                              // setPremiseNumber(e.target.value);
                            }}
                            label={
                              <>
                                <LightTooltipComponent dark title={keyEmptyCheck('addc_registration_no')}>
                                  <Typography component='p' className={classNames(classes.label, classes?.label)}>
                                    {keyEmptyCheck('premise_id')} <span className={classes.textADGMRed}>*</span>
                                  </Typography>
                                </LightTooltipComponent>
                              </>
                            }
                            // error={unit?.failed && !unit?.premiseAddress}
                            disabled={checkPremiseIdStatus()}
                            // isPreFilled={premiseNumber}
                            tabIndex={(isRenewal || isAmendment) && '-1'}
                            customClasses={
                              ((unit?.failed && !unit?.premiseAddress) ||
                                (premiseIdError?.flag && premiseIdError?.id === unit?.plotId)) && {
                                field: classes.textFieldPremise,
                                input: classes.textInput,
                              }
                            }
                          />
                          {((unit?.failed && !unit?.premiseAddress) ||
                            (premiseIdError?.flag && premiseIdError?.id === unit?.plotId)) && (
                            <Typography className={classes.errorPremise}>
                              {keyEmptyCheck('invalid_premise_id')}
                            </Typography>
                          )}
                        </Box>
                        <Hidden mdUp>
                          <Button
                            variant='contained'
                            color='secondary'
                            disabled={unit?.premiseNumber < 1}
                            onClick={() => handleFetchPremise(unit?.premiseNumber, unit?.plotId)}
                            style={{ textTransform: 'none' }}
                          >
                            <FormattedMessage {...messages.fetch} />
                          </Button>
                        </Hidden>
                      </Box>
                    </Grid>
                    <Hidden smDown>
                      <Grid
                        md={3}
                        xs={12}
                        item
                        className={classNames(classes.premiseContent, classes.premiseContentMobile)}
                      >
                        <Box
                          // component={Grid}
                          // md={2}
                          // xs={12}
                          // item
                          align='right'
                          display='flex'
                          justifyContent='flex-end'
                          alignItems='flex-start'
                          pt='26px'
                        >
                          <Button
                            className={lang === 'ar' ? classes.fetchDetailsBtnAr : classes.fetchDetailsBtn}
                            variant='contained'
                            color='secondary'
                            disabled={unit?.premiseNumber < 1}
                            onClick={() => handleFetchPremise(unit?.premiseNumber, unit?.plotId)}
                          >
                            <FormattedMessage {...messages.fetch_details} />
                          </Button>
                        </Box>
                      </Grid>
                    </Hidden>
                    <Grid
                      md={3}
                      xs={12}
                      item
                      className={classNames(classes.premiseContent, classes.premiseContentMobile)}
                    >
                      <Box className={classNames(classes.premiseAddressContainer, classes.premiseContentMobile2)}>
                        <ADGMItemDetails
                          label='premise_address'
                          value={unit?.premiseAddress || '-'}
                          labelClass={classes.lightWeightLable}
                          valueClass={classes.lightWeightValue}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                ))}
              </>
            )}
          </div>
        </Paper>
      )}
    </>
  );
}

LeaseUnitDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  panel: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  propertyDetail: PropTypes.object.isRequired,
  isRenewal: PropTypes.bool,
  isAmendment: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleFetchPremise: PropTypes.func,
  isRegistration: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  isMultipleUnits: PropTypes.bool,
  isVilla: PropTypes.bool,
  applicationId: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  applicationStatus: PropTypes.string.isRequired,
  applicationNumber: PropTypes.string.isRequired,
  applicationType: PropTypes.string.isRequired,
  handleFetchAllPremises: PropTypes.func.isRequired,
  selectedProperties: PropTypes.array,
  premiseIdError: PropTypes.bool,
};

LeaseUnitDetails.defaultProps = {
  isRenewal: false,
  isAmendment: false,
  handleFetchPremise: null,
  isRegistration: false,
  isMultipleUnits: false,
  isVilla: false,
  selectedProperties: [],
  premiseIdError: false,
};

export default withStyles(styles)(injectIntl(LeaseUnitDetails));
